import type { FaireProductEntity } from "../../entity_types/product";

export const p_qy3yhfef2n: FaireProductEntity = {
  token: "p_qy3yhfef2n",
  type: "product",
  name: "Menopause Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/4655ce8f5a88cfb075878cdc85ecc84b4da72b9bcee54b6321bb47a88038e61c.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/48c3a64b63bb50253d00fe617c0e1a370ff57f4e68770a8efbd15f43de846e4f.png",
    "https://cdn.faire.com/fastly/80238f44183a86fc3c93c48a848c2bb44cfa97a575cf34ce7a2eaa63036155f7.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:52.098Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
